"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = login;

require("core-js/modules/es6.object.freeze");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _cssClasses = _interopRequireDefault(require("../../helpers/cssClasses"));

var _utils = require("../../helpers/utils");

var _ebookUtils = require("../../components/ebook-utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/**
 * DOM selectors.
 */


var selectors = {
  customerLoginForm: '[js-password-form="customerLoginForm"]',
  cancelPasswordLink: '[js-password-form="cancelPasswordLink"]',
  recoverPasswordForm: '[js-password-form="recoverPasswordForm"]',
  resetPasswordSuccess: '[js-password-form="resetPasswordSuccess"]',
  forgotPasswordLink: '[js-password-form="forgotPasswordLink"]',
  customerResetPassword: '[js-password-form="customerResetPassword"]'
};

function login() {
  /**
   * DOM Node selectors.
   */
  var nodeSelectors = {
    recoverPasswordForm: document.querySelector(selectors.recoverPasswordForm),
    customerLoginForm: document.querySelector(selectors.customerLoginForm),
    resetPasswordSuccess: document.querySelector(selectors.resetPasswordSuccess),
    cancelPasswordLink: document.querySelector(selectors.cancelPasswordLink),
    forgotPasswordLink: document.querySelector(selectors.forgotPasswordLink),
    customerResetPassword: document.querySelector(selectors.customerResetPassword)
  };
  /**
   * Initialise login form.
   */

  function init() {
    setToggleEvents();
    checkFreeReadsCookie();

    if (nodeSelectors.forgotPasswordLink) {
      checkUrlHash();
      resetPasswordSuccess();
    }
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }
  /**
   * If the user navigates from Free Reads -> Login/Register, a storage item
   * is set. We will now set a storage item for a login/register attempt
   * to reference on the account page later.
   */


  function checkFreeReadsCookie() {
    var loginForm = nodeSelectors.customerLoginForm.querySelector('#customer_login');
    var loginFormBtn = nodeSelectors.customerLoginForm.querySelector('#customer_login_btn');
    var passwordInput = nodeSelectors.customerLoginForm.querySelector('#CustomerPassword');
    var emailInput = nodeSelectors.customerLoginForm.querySelector('#CustomerEmail');
    (0, _utils.on)('click', loginFormBtn, _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var getCustomerAccessTokenResponse, attempts;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (window.sessionStorage.getItem('mb_free_reads') !== null) {
                window.sessionStorage.setItem('mb_submit_attempt', 'login');
              }

              attempts = 0;

            case 2:
              attempts++;
              console.log('attempt', attempts);
              _context.next = 6;
              return (0, _ebookUtils.getCustomerAccessToken)(emailInput.value, passwordInput.value);

            case 6:
              getCustomerAccessTokenResponse = _context.sent;

              if (!(getCustomerAccessTokenResponse === false)) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return sleep(500);

            case 10:
              if (attempts < 11 && getCustomerAccessTokenResponse === false) {
                _context.next = 2;
                break;
              }

            case 11:
              loginForm.submit();
              return _context.abrupt("return", null);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  }
  /**
   * Set toggle events on forgot password and cancel links.
   */


  function setToggleEvents() {
    (0, _utils.on)('click', nodeSelectors.forgotPasswordLink, function (event) {
      return handlePasswordToggle(event);
    });
    (0, _utils.on)('click', nodeSelectors.cancelPasswordLink, function (event) {
      return handlePasswordToggle(event);
    });
  }
  /**
   * Handle login and forgot password form toggle.
   */


  function handlePasswordToggle(event) {
    event.preventDefault();
    toggleRecoverPasswordForm();
  }
  /**
   * Check if #recover is in url hash.
   * - This can occur when the user is coming from an external source.
   */


  function checkUrlHash() {
    if (window.location.hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
  /**
   *  Show/Hide recover password form.
   */


  function toggleRecoverPasswordForm() {
    nodeSelectors.recoverPasswordForm.classList.toggle(_cssClasses["default"].hidden);
    nodeSelectors.customerLoginForm.classList.toggle(_cssClasses["default"].hidden);
  }
  /**
   *  Show reset password success message if posted successfully.
   */


  function resetPasswordSuccess() {
    if (!nodeSelectors.resetPasswordSuccess) {
      return;
    }

    nodeSelectors.customerResetPassword.classList.add(_cssClasses["default"].active);
    nodeSelectors.resetPasswordSuccess.classList.remove(_cssClasses["default"].hidden);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
}

login().init();